import { LineMeasureWidget } from '@inter-ikea-betrakta/viewer/dist/modules/MeasurementWidget';
import { ProductType } from '../../types';
import { MeasurementsEnum } from '../BaseSceneApi';
import EventComponent from '../components/EventComponent';
import { PlannerEcsSystem } from './System';
import OuterMeasurementsComponent from '../components/OuterMeasurementsComponent';
const offset = 0.1;
const scale = 1000;
var Dim;
(function (Dim) {
    Dim["HEIGHT"] = "height";
    Dim["DEPTH"] = "depth";
    Dim["WIDTH"] = "width";
})(Dim || (Dim = {}));
const getHeightLeft = ({ min, max }, alignWithWall) => ({
    wall: 'front',
    dim: Dim.HEIGHT,
    start: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    end: {
        x: min.x / scale - offset,
        y: max.y / scale,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getHeightRight = ({ max, min }, alignWithWall) => ({
    wall: 'front',
    dim: Dim.HEIGHT,
    start: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    end: {
        x: max.x / scale + offset,
        y: max.y / scale,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getWidth = ({ min, max }, alignWithWall) => ({
    wall: 'front',
    dim: Dim.WIDTH,
    start: {
        x: min.x / scale,
        y: max.y / scale + offset,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    end: {
        x: max.x / scale,
        y: max.y / scale + offset,
        z: (alignWithWall ? min.z : max.z) / scale
    },
    cap_direction: { x: 0, y: 1, z: 0 }
});
const getDepthRight = ({ min, max }) => ({
    wall: 'front',
    dim: Dim.DEPTH,
    start: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: min.z / scale
    },
    end: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: max.z / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getDepthLeft = ({ min, max }) => ({
    wall: 'front',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: min.z / scale
    },
    end: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: max.z / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getLeftWallHeightLeft = ({ min, max }, alignWithWall) => ({
    wall: 'left',
    dim: Dim.HEIGHT,
    start: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    end: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: max.y / scale,
        z: max.z / scale + offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getLeftWallHeightRight = ({ min, max }, alignWithWall) => ({
    wall: 'left',
    dim: Dim.HEIGHT,
    start: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    end: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: max.y / scale,
        z: min.z / scale - offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getLeftWallWidth = ({ min, max }, alignWithWall) => ({
    wall: 'left',
    dim: Dim.WIDTH,
    start: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: max.y / scale + offset,
        z: min.z / scale
    },
    end: {
        x: (alignWithWall ? min.x : max.x) / scale,
        y: max.y / scale + offset,
        z: max.z / scale
    },
    cap_direction: { x: 0, y: 1, z: 0 }
});
const getLeftWallDepthRight = ({ min, max }) => ({
    wall: 'left',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    end: {
        x: max.x / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getLeftWallDepthLeft = ({ min, max }) => ({
    wall: 'left',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    end: {
        x: max.x / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getRightWallHeightRight = ({ min, max }, alignWithWall) => ({
    wall: 'right',
    dim: Dim.HEIGHT,
    start: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    end: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: max.y / scale,
        z: max.z / scale + offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getRightWallHeightLeft = ({ min, max }, alignWithWall) => ({
    wall: 'right',
    dim: Dim.HEIGHT,
    start: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    end: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: max.y / scale,
        z: min.z / scale - offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getRightWallWidth = ({ min, max }, alignWithWall) => ({
    wall: 'right',
    dim: Dim.WIDTH,
    start: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: max.y / scale + offset,
        z: min.z / scale
    },
    end: {
        x: (alignWithWall ? max.x : min.x) / scale,
        y: max.y / scale + offset,
        z: max.z / scale
    },
    cap_direction: { x: 0, y: 1, z: 0 }
});
const getRightWallDepthRight = ({ min, max }) => ({
    wall: 'right',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    end: {
        x: max.x / scale,
        y: min.y / scale,
        z: max.z / scale + offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getRightWallDepthLeft = ({ min, max }) => ({
    wall: 'right',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    end: {
        x: max.x / scale,
        y: min.y / scale,
        z: min.z / scale - offset
    },
    cap_direction: { x: 0, y: 0, z: 1 }
});
const getBackHeightLeft = ({ min, max }, alignWithWall) => ({
    wall: 'back',
    dim: Dim.HEIGHT,
    start: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    end: {
        x: max.x / scale + offset,
        y: max.y / scale,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getBackHeightRight = ({ max, min }, alignWithWall) => ({
    wall: 'back',
    dim: Dim.HEIGHT,
    start: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    end: {
        x: min.x / scale - offset,
        y: max.y / scale,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getBackWidth = ({ min, max }, alignWithWall) => ({
    wall: 'back',
    dim: Dim.WIDTH,
    start: {
        x: min.x / scale,
        y: max.y / scale + offset,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    end: {
        x: max.x / scale,
        y: max.y / scale + offset,
        z: (alignWithWall ? max.z : min.z) / scale
    },
    cap_direction: { x: 0, y: 1, z: 0 }
});
const getBackDepthRight = ({ min, max }) => ({
    wall: 'back',
    dim: Dim.DEPTH,
    start: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: min.z / scale
    },
    end: {
        x: max.x / scale + offset,
        y: min.y / scale,
        z: max.z / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
const getBackDepthLeft = ({ min, max }) => ({
    wall: 'back',
    dim: Dim.DEPTH,
    start: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: min.z / scale
    },
    end: {
        x: min.x / scale - offset,
        y: min.y / scale,
        z: max.z / scale
    },
    cap_direction: { x: 1, y: 0, z: 0 }
});
export class MeasurementsWidgetSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'MeasurementsWidgetSystem', EventComponent.id);
        this.coreApi = coreApi;
        this.lines = {};
        this.enabled = true;
        this.walls = [];
    }
    onAdd() { }
    onUpdate(entity, oldComponent, newComponent) {
        if (['update', 'history', 'load'].includes(newComponent.event)) {
            this.onUpdateEvent();
        }
        else if (newComponent.event === 'reset') {
            this.onReset();
        }
    }
    onRemove() { }
    getWalls() {
        this.walls = [];
        const entitiesToMeasure = this.coreApi.entities.getByComponent(OuterMeasurementsComponent.id);
        entitiesToMeasure.forEach((entity) => {
            const wall = this.coreApi.entities.getEntityWall(entity);
            if (!this.walls.includes(wall)) {
                this.walls.push(wall);
            }
        });
    }
    enable() {
        this.enabled = true;
        this.onUpdateEvent();
    }
    disable() {
        this.enabled = false;
        this.hideLines();
    }
    hideLines() {
        if (!this.coreApi.scene) {
            return;
        }
        this.coreApi.scene?.hideMeasurementLines();
    }
    groupByWall(entities) {
        return entities.reduce((acc, entity) => {
            const wall = this.coreApi.entities.getEntityWall(entity);
            acc[wall] = [...(acc[wall] || []), entity];
            return acc;
        }, { left: [], right: [], front: [] });
    }
    onReset() {
        if (this.coreApi.scene) {
            this.coreApi.scene?.setMeasurementLines([]);
        }
    }
    /**
     * Runs on every update. Creates and updates the measurement lines
     * and calculates which lines are visible
     */
    onUpdateEvent() {
        // In the case where we open a mobile qr code the ipexViewer will be undefined and the code below should not run.
        if (!this.coreApi.ipexViewer) {
            return;
        }
        if (!this.enabled) {
            this.hideLines();
            return;
        }
        if (!this.coreApi.scene) {
            return;
        }
        if (this.coreApi.scene?.onlyShowMeasurementIds?.length > 0 &&
            !this.coreApi.scene?.onlyShowMeasurementIds?.includes(MeasurementsEnum.FrameMeasurements)) {
            this.hideLines();
            return;
        }
        this.getWalls();
        const measurementsPerWall = this.coreApi.entities.getOuterMeasurementsPerWall();
        if (!measurementsPerWall) {
            this.lines = {};
            this.coreApi.scene?.setMeasurementLines([]);
            return;
        }
        const frontWallOuterMeasurements = measurementsPerWall['front'];
        const leftWallOuterMeasurements = measurementsPerWall['left'];
        const rightWallOuterMeasurements = measurementsPerWall['right'];
        const backWallOuterMeasurements = measurementsPerWall['back'];
        if (!frontWallOuterMeasurements &&
            !leftWallOuterMeasurements &&
            !rightWallOuterMeasurements &&
            !backWallOuterMeasurements) {
            this.hideLines();
            return;
        }
        const hasMultiWallEntity = this.sceneIncludesMultiwallEntity();
        if (frontWallOuterMeasurements) {
            this.lines = {
                ...this.lines,
                frontHeightLeft: getHeightLeft(frontWallOuterMeasurements, hasMultiWallEntity),
                frontWidth: getWidth(frontWallOuterMeasurements, hasMultiWallEntity),
                frontDepthRight: getDepthRight(frontWallOuterMeasurements),
                frontDepthLeft: getDepthLeft(frontWallOuterMeasurements),
                frontHeightRight: getHeightRight(frontWallOuterMeasurements, hasMultiWallEntity)
            };
        }
        if (leftWallOuterMeasurements) {
            this.lines = {
                ...this.lines,
                leftHeightLeft: getLeftWallHeightLeft(leftWallOuterMeasurements, hasMultiWallEntity),
                leftHeightRight: getLeftWallHeightRight(leftWallOuterMeasurements, hasMultiWallEntity),
                leftWidth: getLeftWallWidth(leftWallOuterMeasurements, hasMultiWallEntity),
                leftDepthRight: getLeftWallDepthRight(leftWallOuterMeasurements),
                leftDepthLeft: getLeftWallDepthLeft(leftWallOuterMeasurements)
            };
        }
        if (rightWallOuterMeasurements) {
            this.lines = {
                ...this.lines,
                rightHeightLeft: getRightWallHeightLeft(rightWallOuterMeasurements, hasMultiWallEntity),
                rightHeightRight: getRightWallHeightRight(rightWallOuterMeasurements, hasMultiWallEntity),
                rightWidth: getRightWallWidth(rightWallOuterMeasurements, hasMultiWallEntity),
                rightDepthRight: getRightWallDepthRight(rightWallOuterMeasurements),
                rightDepthLeft: getRightWallDepthLeft(rightWallOuterMeasurements)
            };
        }
        if (backWallOuterMeasurements) {
            this.lines = {
                ...this.lines,
                backHeightLeft: getBackHeightLeft(backWallOuterMeasurements, hasMultiWallEntity),
                backHeightRight: getBackHeightRight(backWallOuterMeasurements, hasMultiWallEntity),
                backWidth: getBackWidth(backWallOuterMeasurements, hasMultiWallEntity),
                backDepthLeft: getBackDepthLeft(backWallOuterMeasurements),
                backDepthRight: getBackDepthRight(backWallOuterMeasurements)
            };
        }
        const visibleLineIds = this.toggleLines();
        const visibleLines = visibleLineIds.reduce((acc, curr) => {
            return {
                ...acc,
                [curr]: this.lines[curr]
            };
        }, {});
        this.coreApi.scene?.setMeasurementLines(visibleLineIds.map(id => this.convertMeasurementLineToLineMeasureWidget(this.lines[id])));
        const visibleLineCenters = this.getAllVisibleLineCenters(visibleLines);
        this.coreApi.scene?.setMeasurementsLineCenters(visibleLineCenters);
    }
    /**
     * Toggles which lines are visible
     */
    toggleLines() {
        if (!this.coreApi.scene) {
            return [];
        }
        const wallVisibility = this.coreApi.scene?.getWallVisibility();
        if (!wallVisibility) {
            return [];
        }
        const hasMultiWallEntity = this.sceneIncludesMultiwallEntity();
        const pickClosest = (a, b) => (a && b ? a >= b : false);
        const pickFurthest = (a, b) => (a && b ? a <= b : false);
        let lines = [];
        if (this.walls.includes('front')) {
            if (wallVisibility.front) {
                lines = [
                    'frontWidth',
                    this.toggleLine('frontHeightLeft', 'frontHeightRight', hasMultiWallEntity ? pickFurthest : pickClosest),
                    this.toggleLine('frontDepthRight', 'frontDepthLeft', pickFurthest)
                ];
            }
        }
        if (this.walls.includes('left')) {
            if (wallVisibility.left) {
                lines = [
                    ...lines,
                    'leftWidth',
                    this.toggleLine('leftHeightLeft', 'leftHeightRight', hasMultiWallEntity ? pickFurthest : pickClosest),
                    this.toggleLine('leftDepthRight', 'leftDepthLeft', pickFurthest)
                ];
            }
        }
        if (this.walls.includes('right')) {
            if (wallVisibility.right) {
                lines = [
                    ...lines,
                    'rightWidth',
                    this.toggleLine('rightHeightLeft', 'rightHeightRight', hasMultiWallEntity ? pickFurthest : pickClosest),
                    this.toggleLine('rightDepthLeft', 'rightDepthRight', pickFurthest)
                ];
            }
        }
        if (this.walls.includes('back')) {
            if (wallVisibility.back) {
                lines = [
                    ...lines,
                    'backWidth',
                    this.toggleLine('backHeightLeft', 'backHeightRight', hasMultiWallEntity ? pickFurthest : pickClosest),
                    this.toggleLine('backDepthLeft', 'backDepthRight', pickFurthest)
                ];
            }
        }
        return lines;
    }
    /**
     * Toggles the visibility of lines
     * @param lineIndexA index of line, e.g right height line
     * @param lineIndexB index of line, e.g left height line
     * @param comp Function that compares the lines to decide which to render
     * @returns the index of the line that should be shown
     */
    toggleLine(lineA, lineB, comp) {
        if (!this.coreApi.scene)
            return lineB;
        const cameraPosition = this.coreApi.ipexViewer.get_active_camera()?.position;
        if (!cameraPosition)
            return lineB;
        if (!this.lines[lineA] || !this.lines[lineB]) {
            return lineB;
        }
        const distA = this.getDistanceBetweenPoints(cameraPosition, this.getCenter(this.lines[lineA]));
        const distB = this.getDistanceBetweenPoints(cameraPosition, this.getCenter(this.lines[lineB]));
        if (!distA) {
            this.coreApi.scene?.hideMeasurementsLine(this.lines[lineA]);
            return lineB;
        }
        if (!distB) {
            this.coreApi.scene?.hideMeasurementsLine(this.lines[lineB]);
            return lineA;
        }
        if (comp(distA, distB)) {
            this.coreApi.scene?.hideMeasurementsLine(this.lines[lineB]);
            return lineA;
        }
        this.coreApi.scene?.hideMeasurementsLine(this.lines[lineA]);
        return lineB;
    }
    /**
     * Returns the worldposition of a line's center.
     * Now handles cases when line is undefined.
     */
    getCenter(line, scale = 1) {
        if (!line || !line.start || !line.end) {
            this.coreApi.reportErrorToSentry(new Error('Line is undefined or missing start or end point'), { line });
            return { x: 0, y: 0, z: 0 };
        }
        const { start, end } = line;
        return {
            x: (start.x + end.x) * 0.5 * scale,
            y: (start.y + end.y) * 0.5 * scale,
            z: (start.z + end.z) * 0.5 * scale
        };
    }
    getAllVisibleLineCenters(lines) {
        return Object.values(lines).reduce((acc, line) => {
            if (!line.start || !line.end) {
                return acc;
            }
            const center = this.getCenter(line, scale);
            if (center) {
                return [...acc, { position: center, dim: line.dim, wall: line.wall }];
            }
            return acc;
        }, []);
    }
    /**
     * Calculates the length of the vector between the
     * two provided points
     * @returns null if length cannot be calculated
     */
    getDistanceBetweenPoints(pointA, pointB) {
        try {
            return Math.sqrt(Math.pow(pointB.x - pointA.x, 2) +
                Math.pow(pointB.y - pointA.y, 2) +
                Math.pow(pointB.z - pointA.z, 2));
        }
        catch (error) {
            return;
        }
    }
    convertMeasurementLineToLineMeasureWidget(line) {
        return new LineMeasureWidget(this.coreApi.ipexViewer, line.start, line.end, { r: 0, g: 0, b: 0 }, //Color
        0.01, //thickness
        line.cap_direction, 0.03 //cap length
        );
    }
    sceneIncludesMultiwallEntity() {
        return (this.coreApi.entities.getByProductTypes([
            ProductType.PAX_CORNER_SOLUTION_ASM,
            ProductType.IVAR_CORNER_SECTION,
            ProductType.BILLY_CORNER_FITTING,
            ProductType.KNOXHULT_CORNER_CABINET_ASM
        ]).length > 0);
    }
}
//# sourceMappingURL=MeasurementsWidgetSystem.js.map